"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  var moduleName = "login.setupTwoFactors";
  var componentName = "setupTwoFactors";

  var bindings = {
    resolve: "<?",
    close: "&?",
    dismiss: "&?"
  };

  var templateUrl = "app/pages/login/setupTwoFactors/setupTwoFactors.html";

  var Controller = function () {
    /** @ngInject */
    function Controller(UsersService, $rootScope, $scope) {
      _classCallCheck(this, Controller);

      this.UsersService = UsersService;
      this.$rootScope = $rootScope;
      this.$scope = $scope;
    }

    _createClass(Controller, [{
      key: "$onInit",
      value: function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var response;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return this.UsersService.post("2fa/setup");

                case 2:
                  response = _context.sent;

                  if (response.qrCode) {
                    _context.next = 5;
                    break;
                  }

                  throw response;

                case 5:

                  this.qrCodeUrl = response.qrCode;
                  this.secret = response.secret;

                  this.$scope.$apply();

                case 8:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function $onInit() {
          return _ref.apply(this, arguments);
        }

        return $onInit;
      }()
    }, {
      key: "verify",
      value: function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          var response;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return this.UsersService.post("2fa/verify", {
                    secret: this.secret,
                    code: this.code
                  });

                case 2:
                  response = _context2.sent;


                  if (!response.success) {
                    Notiflix.Notify.failure(response.message);
                  } else {
                    Notiflix.Notify.success("2FA activé avec succès");
                    this.close();
                  }

                case 4:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function verify() {
          return _ref2.apply(this, arguments);
        }

        return verify;
      }()
    }]);

    return Controller;
  }();

  angular.module(moduleName).component(componentName, {
    templateUrl: templateUrl,
    bindings: bindings,
    transclude: true,
    controller: Controller
  });
})();